export { EADataDepth } from './generated/EADataDepth.js';